import styled from 'styled-components';

export const HeaderContainer = styled.header`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #282c34;
  padding: 20px;
  color: white;
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 1.5em;
  padding-bottom: 10px;
  text-decoration: underline;
`;

export const StockInfo = styled.p`
  margin: 5px 0;
`;